import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Footer from "@/components/Footer";

/**
 * Wrapper used by all legal pages (Privacy, Terms, Sales Terms).
 * Keeps a consistent reading experience and provides a "back home" link.
 */
export default function LegalLayout({ title, updatedAt, children }) {
  return (
    <div className="min-h-screen bg-[var(--bg-1)] text-[var(--fg-1)]">
      <header className="border-b border-[var(--border-c)]">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-[var(--fg-2)] hover:text-[var(--fg-1)]"
            style={{ transition: "color 0.2s ease" }}
          >
            <ArrowLeft size={14} /> Torna alla home
          </Link>
          <div className="font-sans text-lg">
            <span className="text-[var(--fg-1)]">Recen</span>
            <span className="italic text-[#00F2F4]">Up</span>
          </div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-16">
        <div className="text-[10px] uppercase tracking-[0.25em] text-[var(--fg-3)] font-sans">
          Documento legale
        </div>
        <h1 className="mt-2 font-serif text-4xl md:text-5xl text-[var(--fg-1)] tracking-tight">
          {title}
        </h1>
        {updatedAt && (
          <p className="mt-3 text-xs text-[var(--fg-3)] font-sans">
            Ultimo aggiornamento: {updatedAt}
          </p>
        )}
        <div
          data-testid="legal-content"
          className="mt-10 space-y-6 text-sm md:text-[15px] leading-relaxed text-[var(--fg-2)] font-sans
                     [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:text-[var(--fg-1)] [&_h2]:mt-10 [&_h2]:mb-2 [&_h2]:tracking-tight
                     [&_h3]:font-sans [&_h3]:font-semibold [&_h3]:text-base [&_h3]:text-[var(--fg-1)] [&_h3]:mt-6 [&_h3]:mb-1
                     [&_p]:mb-3
                     [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1
                     [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:space-y-1
                     [&_a]:text-[#00A8AA] [&_a:hover]:text-[#00F2F4] [&_a]:underline
                     [&_code]:font-mono [&_code]:text-xs [&_code]:bg-[var(--bg-3)] [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:rounded"
        >
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
}
